/* eslint-disable max-params */
import React from "react";
import H2 from "../../shared/h2/component";
import styles from "./styles.css";
import ArrowIcon from "../../shared/arrow";
import { NUMBER } from "../../../constants/app-constants";
import PropTypes from "prop-types";
import infoIcon from "./images/infoIcon.svg";
import WhiteCardNew from "../../shared/white-card-new";

const ConfirmationDocumentsFaq = ({
    faqs,
    isOpenCategories,
    setIsOpenCategories
}) => {
    const getFilterOpen = (data, index, isOpen) => {
        return data.map((item, i) => {
            if (index === i) {
                item.isOpen = isOpen;
            } else {
                item.isOpen = false;
            }
            return item;
        });
    };
    const onClickOpenFaq = (index) => {
        let openState = [...isOpenCategories];
        const isOpen = !openState[index].isOpen;
        openState = getFilterOpen(openState, index, isOpen);
        setIsOpenCategories([...openState]);
    };
    const onClickOpenOptionFaq = (index, i) => {
        const openState = isOpenCategories;
        const isOpen = !openState[index].list[i].isOpen;
        openState[index].list = getFilterOpen(openState[index].list, i, isOpen);
        setIsOpenCategories([...openState]);
    };
    const onClickListItemFaq = (index, i, k)  => {
        const openState = isOpenCategories;
        const isOpen = isOpenCategories[index].list[i].listItem[k].isOpen;
        openState[index].list[i].listItem = getFilterOpen(openState[index].list[i].listItem, k, isOpen);
        setIsOpenCategories([...openState]);
    };
    const getAnswer = (opt, isOpen) => {
        return (<div className={styles.hoverWrapper}>
            <img src={infoIcon} alt="info" />
            <p styleName={`${ isOpen ? "styles.content" : ""}`} dangerouslySetInnerHTML={
                { __html: opt.answer }
            } />
        </div>);
    };
    const getCategories = (categories, item, index, i) => {
        let component = null;
        if (categories === NUMBER.TWO) {
            component = (<div styleName={`${ isOpenCategories[index].isOpen ? "styles.content" : "styles.contentHide"}`}>
                <h4 styleName={"styles.childWrapper"} onClick={() => onClickOpenOptionFaq(index, i)}>
                    {item.label}
                </h4>
                {item.subOption && item.subOption.length && item.subOption.map((opt, k) => (
                    <React.Fragment key={k}>
                        <div>
                            <div styleName={`${ isOpenCategories[index].list[i].isOpen ? "styles.content" : "styles.contentHide"}`}>
                                <h4 onClick={() => onClickListItemFaq(index, i, k)}>
                                    {opt.label}
                                    {getAnswer(opt, isOpenCategories[index].list[i].listItem[k].isOpen)}
                                </h4>
                            </div>
                        </div>
                    </React.Fragment>
                ))}
            </div>);
        } else if (categories === NUMBER.ONE) {
            component = (<div styleName={`${isOpenCategories[index].isOpen ? "styles.content" : "styles.contentHide"}`}>
                <h4>
                    {item.label}
                    {getAnswer(item, isOpenCategories[index].list[i].isOpen)}
                </h4>
                {item.description && <span>{item.description}</span>}
            </div>);
        }
        return component;
    };
    const rightArrow = 90;
    const downArrow = -90;
    return (
        <div className={styles.documentsFaq}>
            <H2 text="Documents to be carried along during inspection" />
            <div className={styles.faqDocumentWrapper}>
                { faqs &&
                    faqs.map((data, index) =>
                        (<div className={styles.cardWrapper} key={index}>
                            <WhiteCardNew>
                                <div styleName={"styles.wrap"}>
                                    <h3 styleName={"styles.title"}
                                        onClick={() => onClickOpenFaq(index)}
                                    >{data.question}
                                        <ArrowIcon rotateBy={isOpenCategories[index].isOpen ? downArrow : rightArrow} />
                                    </h3>
                                    {data.option.map((item, i) => (
                                        <React.Fragment key={i} >
                                            {getCategories(data.categories, item, index, i)}
                                        </React.Fragment>
                                    ))}
                                    {data.answer &&
                                    <p className={`${ isOpenCategories[index].isOpen ? styles.linkContent : styles.contentHide}`} dangerouslySetInnerHTML={
                                        { __html: data.answer }
                                    } />
                                    }
                                </div>
                            </WhiteCardNew>
                        </div>
                        ))
                }
            </div>

        </div>
    );
};
ConfirmationDocumentsFaq.propTypes = {
    faqs: PropTypes.array,
    isOpenCategories: PropTypes.array,
    setIsOpenCategories: PropTypes.func
};
export default ConfirmationDocumentsFaq;
